'use strict';

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Str = void 0;

var crypto_1 = __importDefault(require("crypto"));

var uuid_1 = require("uuid");

var Str = /*#__PURE__*/function () {
  /**
   * Create a new String instance providing chainable string operations.
   * This instance clones the original string and works with the clone.
   * It won’t modify the original string.
   *
   * @param {String} value
   *
   * @returns {Str}
   */
  function Str(value) {
    _classCallCheck(this, Str);

    this.value = String(value || '').slice(0);
  }
  /**
   * Returns a URL-friendly alphabet containing the symbols `a-z A-Z 0-9 _-`.
   * The symbols order was changed for better gzip compression.
   *
   * The alphabet comes from the https://github.com/ai/nanoid package.
   *
   * @returns {String}
   */


  _createClass(Str, [{
    key: "get",

    /**
     * Returns the string value.
     *
     * @returns {String}
     */
    value: function get() {
      return this.toString();
    }
    /**
     * Returns the string value.
     *
     * @returns {String}
     */

  }, {
    key: "toString",
    value: function toString() {
      return this.value;
    }
    /**
     * Returns the portion of the string after the first occurrence of the given `delimiter`.
     *
     * @param {String} delimiter
     *
     * @returns {Str}
     */

  }, {
    key: "after",
    value: function after(delimiter) {
      if (delimiter === '') {
        return this;
      }

      var substrings = this.split(delimiter);
      return substrings.length === 1 ? this // delimiter is not part of the string
      : new Str(substrings.slice(1).join(delimiter));
    }
    /**
     * Returns the portion of the string after the last occurrence of the given `delimiter`.
     *
     * @param {String} delimiter
     *
     * @return {Str}
     */

  }, {
    key: "afterLast",
    value: function afterLast(delimiter) {
      return delimiter === '' ? this : new Str(this.split(delimiter).pop());
    }
    /**
     * Append the given values to the string.
     *
     * @param {String|String[]} values
     *
     * @return {Str}
     */

  }, {
    key: "append",
    value: function append() {
      var _ref;

      return new Str(this.value + (_ref = []).concat.apply(_ref, arguments).join(''));
    }
    /**
     * Returns the portion of the string before the first occurrence of the given `delimiter`.
     *
     * @param {String} delimiter
     *
     * @returns {Str}
     */

  }, {
    key: "before",
    value: function before(delimiter) {
      return delimiter === '' ? this : new Str(this.split(delimiter).shift());
    }
    /**
     * Returns the portion of the string before the last occurrence of the given `delimiter`.
     *
     * @param {String} delimiter
     *
     * @return {Str}
     */

  }, {
    key: "beforeLast",
    value: function beforeLast(delimiter) {
      if (delimiter === '') {
        return this;
      }

      var substrings = this.split(delimiter);
      return substrings.length === 1 ? this // delimiter is not part of the string
      : new Str(substrings.slice(0, -1).join(delimiter));
    }
    /**
     * Convert the string to camelCase.
     *
     * @returns {Str}
     */

  }, {
    key: "camel",
    value: function camel() {
      return this.studly().lcFirst();
    }
    /**
     * Returns a string that contains the concatenation of two or more strings.
     *
     * @param {String|Array} strings
     *
     * @returns {Str}
     */

  }, {
    key: "concat",
    value: function concat() {
      var _ref2, _this$value;

      for (var _len = arguments.length, strings = new Array(_len), _key = 0; _key < _len; _key++) {
        strings[_key] = arguments[_key];
      }

      strings = (_ref2 = []).concat.apply(_ref2, _toConsumableArray(strings));
      return new Str((_this$value = this.value).concat.apply(_this$value, _toConsumableArray(strings)));
    }
    /**
     * Determine whether the haystack contains any of the given `needles`.
     *
     * @param {String} needle
     *
     * @returns {Boolean}
     */

  }, {
    key: "contains",
    value: function contains() {
      return this.includes.apply(this, arguments);
    }
    /**
     * Determine whether the haystack contains all items if the `needles` array.
     *
     * @param {String} needle
     *
     * @returns {Boolean}
     */

  }, {
    key: "containsAll",
    value: function containsAll() {
      return this.includesAll.apply(this, arguments);
    }
    /**
     * Determine whether the haystack does not contain the given `needle`.
     *
     * @param {String} needle
     *
     * @returns {Boolean}
     */

  }, {
    key: "notContains",
    value: function notContains(needle) {
      return !this.contains(needle);
    }
    /**
     * Determine whether the string ends with the given `needle`.
     * Optionally, accepts a `length` used as the string length.
     *
     * @param {String} needle
     * @param {Number} length
     *
     * @returns {Boolean}
     */

  }, {
    key: "endsWith",
    value: function endsWith(needle, length) {
      return this.value.endsWith(needle, length);
    }
    /**
     * Determine whether the string equals the given `value`.
     *
     * @param {String} value
     *
     * @returns {Boolean}
     */

  }, {
    key: "equals",
    value: function equals(value) {
      return this.value === value;
    }
    /**
     * Determine whether the string does not equal the given `value`.
     *
     * @param {String} value
     *
     * @returns {Boolean}
     */

  }, {
    key: "notEquals",
    value: function notEquals(value) {
      return !this.equals(value);
    }
    /**
     * Append a single instance of the given `suffix` to the end of
     * the string if it doesn’t already ends with the given suffix.
     *
     * @param {String} suffix
     *
     * @returns {Str}
     */

  }, {
    key: "finish",
    value: function finish(suffix) {
      return this.endsWith(suffix) ? this : this.append(suffix);
    }
    /**
     * Determine whether the given string contains the `needle`.
     *
     * @param {*} needle
     *
     * @returns {Boolean}
     */

  }, {
    key: "includes",
    value: function includes() {
      var _ref3,
          _this = this;

      var includes = (_ref3 = []).concat.apply(_ref3, arguments).filter(function (needle) {
        return needle !== '';
      }).find(function (needle) {
        return _this.value.includes(needle);
      });

      return !!includes;
    }
    /**
     * Determine whether the haystack contains all items if the `needles` array.
     *
     * @param {String} needle
     *
     * @returns {Boolean}
     */

  }, {
    key: "includesAll",
    value: function includesAll() {
      var _ref4,
          _this2 = this;

      return (_ref4 = []).concat.apply(_ref4, arguments).every(function (needle) {
        return _this2.includes(needle);
      });
    }
    /**
     * Determine whether the string does not contain the given `needle`.
     *
     * @param {String} needle
     *
     * @returns {Boolean}
     */

  }, {
    key: "notIncludes",
    value: function notIncludes(needle) {
      return !this.includes(needle);
    }
    /**
     * Determine whether the given string is empty.
     *
     * @returns {Boolean}
     */

  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.length() === 0;
    }
    /**
     * Determine whether the string is lowercase.
     *
     * @returns {Boolean}
     */

  }, {
    key: "isLower",
    value: function isLower() {
      return this.isLowercase();
    }
    /**
     * Determine whether the string is lowercase.
     *
     * @returns {Boolean}
     */

  }, {
    key: "isLowercase",
    value: function isLowercase() {
      return this.value === this.lower().get();
    }
    /**
     * Determine whether the given string is not empty.
     *
     * @returns {Boolean}
     */

  }, {
    key: "isNotEmpty",
    value: function isNotEmpty() {
      return !this.isEmpty();
    }
    /**
     * Determine whether the given `input` is a string.
     *
     * @param {*} input
     *
     * @returns {Boolean}
     */

  }, {
    key: "isString",
    value: function isString(input) {
      return typeof input === 'string' && Object.prototype.toString.call(input) === '[object String]';
    }
    /**
     * Determine whether the given string is uppercase.
     *
     * @returns {Boolean}
     */

  }, {
    key: "isUpper",
    value: function isUpper() {
      return this.isUppercase();
    }
    /**
     * Determine whether the given string is uppercase.
     *
     * @returns {Boolean}
     */

  }, {
    key: "isUppercase",
    value: function isUppercase() {
      return this.value === this.upper().get();
    }
    /**
     * Convert the string to kebab-case.
     *
     * @returns {Str}
     */

  }, {
    key: "kebab",
    value: function kebab() {
      return new Str(this.value.replace(/[_-\s]+/g, '-')).strip().toLowerCase();
    }
    /**
     * Lowercases the first character in the string.
     *
     * @returns {Str}
     */

  }, {
    key: "lcFirst",
    value: function lcFirst() {
      return new Str(this.value[0].toLowerCase() + this.value.slice(1));
    }
    /**
     * Returns the string’s length.
     *
     * @returns {Number}
     */

  }, {
    key: "length",
    value: function length() {
      return this.value.length;
    }
    /**
     * Returns the first `limit` characters and ends the limited string with `end`.
     *
     * @param {Number} limit
     * @param {String} end
     *
     * @returns {Str}
     */

  }, {
    key: "limit",
    value: function limit() {
      var _limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return _limit >= this.length() ? this : new Str(this.value.substring(0, _limit).concat(end));
    }
    /**
     * Lowercases the string.
     *
     * @returns {Str}
     */

  }, {
    key: "lower",
    value: function lower() {
      return this.toLowerCase();
    }
    /**
     * Lowercases the string. Alias for `.lower()`.
     *
     * @returns {Str}
     */

  }, {
    key: "lowercase",
    value: function lowercase() {
      return this.toLowerCase();
    }
    /**
     * Removes the whitespace from the front of the string when
     * no argument is present. It trims the given `characters`
     * from the left of the string if you pass along a value.
     *
     * @param {String} characters
     *
     * @returns {Str}
     */

  }, {
    key: "ltrim",
    value: function ltrim() {
      var characters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (!characters) {
        return new Str(this.value.trimLeft());
      }

      while (this.startsWith(characters)) {
        this.value = this.replace(characters, '').get();
      }

      return new Str(this.value);
    }
    /**
     * Pad the left side of the string with the given `pad` string (repeatedly
     * if needed) so that the resulting string reaches a given `length`.
     *
     * @param {Number} length
     * @param {String} pad
     *
     * @returns {Str}
     */

  }, {
    key: "padLeft",
    value: function padLeft(length) {
      var pad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
      return new Str(this.value.padStart(length, pad));
    }
    /**
     * Pad the right side of the string with the given `pad` string (repeatedly
     * if needed) so that the resulting string reaches a given `length`.
     *
     * @param {Number} length
     * @param {String} pad
     *
     * @returns {Str}
     */

  }, {
    key: "padRight",
    value: function padRight(length) {
      var pad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
      return new Str(this.value.padEnd(length, pad));
    }
    /**
     * Convert the string to PascalCase (same as StudlyCase). Alias for `.studly()`.
     *
     * @returns {Str}
     */

  }, {
    key: "pascal",
    value: function pascal() {
      return this.studly();
    }
    /**
     * Prepend the given values to the string.
     *
     * @param {String|String[]} values
     *
     * @return {Str}
     */

  }, {
    key: "prepend",
    value: function prepend() {
      var _ref5;

      return new Str((_ref5 = []).concat.apply(_ref5, arguments).join('') + this.value);
    }
    /**
     * Create a random, URL-friendly string. The default length will have 21 symbols.
     *
     * @param {Number} [size=21] number of symbols in string
     *
     * @returns {String}
     */

  }, {
    key: "random",
    value: function random() {
      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;
      var bytes = crypto_1["default"].randomBytes(size);
      var alphabetLength = Str.alphabet.length - 1;
      var random = '';

      while (size--) {
        random += Str.alphabet[bytes[size] & alphabetLength];
      }

      return random;
    }
    /**
     * Replace the first occurence of the string.
     *
     * @param {String} search
     * @param {String} replace
     *
     * @returns {Str}
     */

  }, {
    key: "replace",
    value: function replace(search, _replace) {
      return new Str(this.value.replace(search, _replace));
    }
    /**
     * Replace all occurrences of `search` with `replace` in the string.
     *
     * @param {*} search
     * @param {*} replace
     *
     * @returns {Str}
     */

  }, {
    key: "replaceAll",
    value: function replaceAll(search, replace) {
      var replacer = new RegExp(search, 'g');
      return new Str(this.value.replace(replacer, replace));
    }
    /**
     * Replace the last occurence of the string.
     *
     * @param {String} search
     * @param {String} replace
     *
     * @returns {Str}
     */

  }, {
    key: "replaceLast",
    value: function replaceLast(search, replace) {
      return this.notContains(search) ? this : new Str(this.beforeLast(search).get() + replace + this.afterLast(search).get());
    }
    /**
     * Returns the reversed string.
     *
     * @returns {Str}
     */

  }, {
    key: "reverse",
    value: function reverse() {
      return new Str(this.value.split('').reverse().join(''));
    }
    /**
     * Removes the whitespace from the end of the string when
     * no argument is present. It trims the given `characters`
     * from the left of the string if you pass along a value.
     *
     * @param {String} characters
     *
     * @returns {Str}
     */

  }, {
    key: "rtrim",
    value: function rtrim() {
      var characters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (!characters) {
        return new Str(this.value.trimRight());
      }

      while (this.endsWith(characters)) {
        this.value = this.replaceLast(characters, '').get();
      }

      return new Str(this.value);
    }
    /**
     * Convert the string to snake_case.
     *
     * @returns {Str}
     */

  }, {
    key: "snake",
    value: function snake() {
      return new Str(this.value.replace(/[_-\s]+/g, '_')).strip().toLowerCase();
    }
    /**
     * Splits up the string into an array of strings by separating
     * the string at each of the specified `separator` string.
     *
     * @param {String} separator
     * @param {Number} limit
     *
     * @returns {Array}
     */

  }, {
    key: "split",
    value: function split(separator, limit) {
      return this.value.split(separator, limit);
    }
    /**
     * Prepends a single instance of the given `prefix` to the start of
     * the string if it doesn’t already start with the given prefix.
     *
     * @param {String} prefix
     *
     * @returns {Str}
     */

  }, {
    key: "start",
    value: function start(prefix) {
      return this.startsWith(prefix) ? this : this.prepend(prefix);
    }
    /**
     * Determine whether the string starts with the given `needle`.
     * Optionally, accepts the position in the string at which
     * to begin searching for the `needle` (defaults to `0`).
     *
     * @param {*} needle
     * @param {Number} position
     *
     * @returns {Boolean}
     */

  }, {
    key: "startsWith",
    value: function startsWith(needle, position) {
      return this.value.startsWith(needle, position);
    }
    /**
     * Removes all whitespace from the string, everywhere.
     *
     * @returns {Str}
     */

  }, {
    key: "strip",
    value: function strip() {
      return new Str(this.value.replace(/\s+/g, ''));
    }
    /**
     * Removes all numbers from the string.
     *
     * @returns {Str}
     */

  }, {
    key: "stripNums",
    value: function stripNums() {
      return this.replaceAll(/\d+/, '');
    }
    /**
     * Convert the string to StudlyCase. StudlyCase is similar to camelCase
     * except that the first character is uppercase instead of lowercase.
     *
     * @returns {Str}
     */

  }, {
    key: "studly",
    value: function studly() {
      return new Str(this.value.replace(/[_-]+/g, ' ')).title().strip();
    }
    /**
     * Returns the substring.
     *
     * @param {Number} start
     * @param {Number} length
     *
     * @returns {Str}
     */

  }, {
    key: "substr",
    value: function substr(start, length) {
      return new Str(this.value.substring(start, length));
    }
    /**
     * Convert the string to title case.
     *
     * @returns {Str}
     */

  }, {
    key: "title",
    value: function title() {
      return new Str(this.lowercase().split(' ').filter(function (s) {
        return s;
      }).map(function (s) {
        return s[0].toUpperCase() + s.slice(1);
      }).join(' '));
    }
    /**
     * Lowercases the string. Alias for `.lower()` and convenience
     * method to comply with the global String’s `.toLowerCase()`.
     *
     * @returns {Str}
     */

  }, {
    key: "toLowerCase",
    value: function toLowerCase() {
      return new Str(this.value.toLowerCase());
    }
    /**
     * Uppercases the string. Alias for `.upper()` and convenience
     * method to comply with the global String’s `.toUpperCase()`.
     *
     * @returns {Str}
     */

  }, {
    key: "toUpperCase",
    value: function toUpperCase() {
      return new Str(this.value.toUpperCase());
    }
    /**
     * Removes whitespace around the string, front and back when no argument
     * is present. It trims the given `characters` from the left and right
     * of the string if you pass along a value.
     *
     * @param {String} characters
     *
     * @returns {Str}
     */

  }, {
    key: "trim",
    value: function trim() {
      var characters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.ltrim(characters).rtrim(characters);
    }
    /**
     * Uppercases the first character in the string.
     *
     * @returns {Str}
     */

  }, {
    key: "ucFirst",
    value: function ucFirst() {
      return new Str(this.value[0].toUpperCase() + this.value.slice(1));
    }
    /**
     * Uppercases the string.
     *
     * @returns {Str}
     */

  }, {
    key: "upper",
    value: function upper() {
      return this.toUpperCase();
    }
    /**
     * Uppercases the string. Alias for `.upper()`.
     *
     * @returns {Str}
     */

  }, {
    key: "uppercase",
    value: function uppercase() {
      return this.toUpperCase();
    }
    /**
     * Create a UUID (version 4).
     *
     * @returns {String}
     */

  }, {
    key: "uuid",
    value: function uuid() {
      return uuid_1.v4();
    }
  }], [{
    key: "alphabet",
    get: function get() {
      return 'ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW';
    }
  }]);

  return Str;
}();

exports.Str = Str;